import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddEditMeal from '../components/TrackerAddEditMeal';
import TrackerQuickMealForm from '../QuickMeal/TrackerQuickMealForm';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeTrackerMeal } from '../helpers/normalizers';
import { normalizeQuickMeal } from '../QuickMeal/helpers';
import { TrackerMealProps } from '../types';

const TrackerMealContainer: React.FC<TrackerMealProps> = (props) => {
  sessionStorage.setItem('tracker_depth', '1');

  // A quick meal has no products and is edited through its own mutation (`editMeal` rejects it).
  if (props.trackerMealData.isQuickMeal) {
    return (
      <TrackerQuickMealForm
        key={props.trackerMealData.id}
        mealData={normalizeQuickMeal(props.trackerMealData)}
        editQuickMeal={props.editQuickMeal}
        removeMeal={props.removeMeal}
        saveAsUserMeal={props.saveAsUserMeal}
        date={props.date}
      />
    );
  }

  const normalizedProps = normalizeTrackerMeal(props);
  return <TrackerAddEditMeal key={normalizedProps.mealData.id} {...normalizedProps} />;
};

export default withLoading(TrackerMealContainer, UniversalPlaceholder);
